// options
const allGenders = ['Female', 'Male'];
const allAges = ['0 - 14', '15 - 24', '25 - 34', '35 - 44', '45 - 54', '55+'];
const allInterests = ['football', 'hockey', 'speaking Klingon', 'spelling bee', 'my little pony', 'furry convention',];
function convertAgeGroups(ageGroups) {
    const newAges = ageGroups.map(ageGrp => `ageGroup_${ageGrp.replace(/\s/g, '')}`);
    return JSON.stringify(newAges);
}
export { allGenders, allAges, allInterests, convertAgeGroups };
